var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"language-switcher",attrs:{"title":_vm.$t('switchLanguageTitle')},on:{"click":_vm.switchLanguage}},[_c('span',{attrs:{"aria-label":_vm.$t('switchLanguageAlt')}},[_vm._v(_vm._s(_vm.$root.$i18n.locale))])])}
var staticRenderFns = []

export { render, staticRenderFns }